import React from 'react';
import noImageUrl from '@app/assets/images/no-image.png';

/** Ảnh mặc định được bundle qua webpack nên URL luôn tồn tại (không như đường dẫn tĩnh tự đặt). */
export const IMAGE_FALLBACK: string = noImageUrl;

/**
 * Đổi sang ảnh mặc định đúng MỘT lần.
 *
 * Nếu gán src trong onError mà không chặn, khi chính ảnh mặc định cũng lỗi thì trình duyệt
 * sẽ bắn onError → gán lại src → tải lại → lặp vô hạn (mỗi option là một vòng request 404).
 */
export const applyImageFallback = (event: React.SyntheticEvent<HTMLImageElement>): void => {
  const img = event.currentTarget;
  if (img.dataset.fallbackApplied === 'true') return;

  img.dataset.fallbackApplied = 'true';
  img.src = IMAGE_FALLBACK;
};
